export const messages = {
  NEEDS_LOGIN: '로그인 후에 이용해주세요',
  UNKNOWN_ERROR: '잠시 후 다시 시도해주세요',
  LOGIN_SESSION_EXPIRED: '로그인 세션이 만료되었습니다 다시 로그인해주세요',
  FAILED_TO_EDIT: '수정에 실패하였습니다',

  USER_WITHDRAWAL_CHECK_FIELDS: '약관을 읽고 체크해주세요',
  USER_WITHDRAWAL_SUCCESS: '회원탈퇴가 정상적으로 처리되었습니다',
  USER_WITHDRAWAL_FAILED:
    '회원탈퇴에 실패하였습니다 계속해서 해당 메세지가 뜨면 codenary@wantedlab.com으로 문의주세요',

  LOGIN_NOT_FOUND: '가입된 계정이 없습니다',

  NICKNAME_CHECK_FAILED: '형식에 맞는 닉네임을 사용해주세요',
  NEEDS_NICKNAME_CHECK: '닉네임을 다시 한번 확인해주세요',
  REGISTER_FAILED: '회원가입에 실패하였습니다 다시 시도해주세요',
  REGISTER_NEEDS_AGREEMENT: '서비스 이용약관 동의가 필요해요',
  PROFILE_IMAGE_UPLOADED_SUCCESSFUL: '프로필 이미지 변경 완료',
  PROFILE_IMAGE_UPLOADED_FAILED:
    '프로필 이미지 변경에 실패하였습니다. 잠시 후 다시 시도해주세요.',

  EMAIL_VERIFICATION_FAILED: '인증번호를 확인해주세요',

  COPY_TO_CLIPBOARD: '클립보드에 복사 완료!',

  COMMENT_NOT_CHANGED: '댓글이 수정되지 않았습니다',
  REPORT_REASON_NOT_DESCRIBED: '신고 사유를 선택해주세요',
  REPORT_SUBMITTED_SUCCESSFULLY: '신고가 접수되었어요',

  NEWSLETTER_NOT_VALID: '유효하지 않은 뉴스레터입니다',
  ADD_NEWCOMPANY_SUCCESSFUL: '기업 정보 제출 완료',
  ADD_NEWCOMPANY_ERROR: '기업 제출에 실패하였습니다. 다시 시도해주세요',
  ADD_NEWCOMPANY_INCOMPLETE: '필수 사항을 모두 기입해주세요.',

  EDIT_COMPANY_REQUEST_SUCCESS: '수정 요청이 제출되었습니다',
  EDIT_COMPANY_REQUREST_FAILED:
    '수정 요청에 실패하였습니다 잠시 후 다시 시도해주세요',

  SCHEDULE_REQUEST_SUCCESS: '추가 요청이 제출되었습니다',
  SCHEDULE_REQUREST_FAILED:
    '추가 요청에 실패하였습니다 잠시 후 다시 시도해주세요',

  USERPROFILE_NEEDS_BASIC_INFO: '기본 정보를 모두 채워주세요',
  USERPROFILE_NEEDS_SNS_INFO: 'SNS 정보를 모두 채워주세요',
  USERPROFILE_SYNC_RSS_ADDRESS_NEEDS_CHECK: '올바른 주소를 입력해주세요',
  USERPROFILE_SYNC_ID_ERROR: 'ID를 다시 한번 확인해주세요',
  USERPROFILE_SYNC_SUCCESSFUL:
    '컨텐츠를 가지고 오는데 시간이 조금 걸릴 수 있어요',
  USERPROFILE_SYNC_FAILED: '유효하지 않은 계정입니다. 다시 한번 확인해주세요',
  USERPROFILE_UNSYNC_SUCCESSFUL: '계정 연동 해제 완료',
  USERPROFILE_UNSYNC_FAILED:
    '계정 연동 해제에 실패하였습니다. 다시 시도해주세요',
  USERPROFILE_CONTENT_SYNC_VALIDATION_FALIED:
    '연동 해지 후 30분 뒤에 연동하실 수 있습니다.',
  USERPROFILE_CONTENT_UNSYNC_VALIDATION_FAILED:
    '컨텐츠가 내부적인 작업 중에 있어요. 조금 뒤에 다시 시도해주세요.',

  USERPROFILE_SUBMISSION_SUCCESSFUL: '정상적으로 반영되었습니다',
  USERPROFILE_SUBMISSION_FAILED: '제출 실패 정보를 다시 한번 확인해주세요',

  ADD_COMMENT_NOT_SIGNEDIN_USER: '로그인 후에 댓글을 남겨주세요',
  ADD_COMMENT_VACANT: '내용을 입력해주세요',

  BOOKMARK_ADDED_SUCCESSFUL: '북마크에 저장하였습니다',
  BOOKMARK_DELETED_SUCCESSFUL: '북마크에서 제거하였습니다',

  UPDATE_USER_PROFILE: '내 정보를 수정하였습니다.',
  NEWS_SLACK_SYNC_SUCCESSFUL: '슬랙이 정상적으로 연동되었습니다.',

  JOBPOST_TECHSTACK_REQUIRED: '먼저 내 기술 스택을 등록해주세요',
};
